import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IntlProvider, ReactIntlErrorCode } from 'react-intl';
import _ from 'lodash';

import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';

import useGlobalStatus from './hook/useGlobalStatus';

import AppRoute from './route/routes';
import theme from './theme';
import 'normalize.css';
import { i18nMessages } from './i18n';
import * as basicConstants from './constants/basic';
import { PAGE_DATA } from './constants/url';


const App = () => {
  const location = useLocation();
  const { locale, setLocale } = useGlobalStatus();
  const currentPage = _.filter(PAGE_DATA, el => el.path === location.pathname);
  const currenttitle = currentPage.length > 0 ? `${currentPage[0].title}${basicConstants.TITLE_PRODUCT_NAME}` : `${basicConstants.TITLE_PRODUCT_NAME}`;
  document.title = currenttitle;

  let messages;

  // console.log('locale', locale);    
  // console.log('navigator.language', navigator.language);
  // console.log('navigator.languages', navigator.languages);

  if (locale.includes("zh")) {
    messages = i18nMessages.zh;
  } else if (locale.includes("en")) {
    messages = i18nMessages.en;
  } else if (locale.includes("ja")) {
    messages = i18nMessages.ja;
  } else {
    messages = i18nMessages.zh;
  }

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={messages}
      onError={(err) => {
        if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
          console.warn(`缺少翻譯：${err.message}`);
        } else {
          throw err;
        }
      }}
      // defaultLocale='zh-TW'
    >
      <ThemeProvider theme={theme}>
        <Box>
          <AppRoute />
        </Box>
      </ThemeProvider>
    </IntlProvider >
  );
}

export default App;
